import React from 'react';

import { Route, IndexRoute } from 'react-router';
import {
  loadRoute,
  prepareInfiniteScrollParams,
  render,
  ViewerQueries,
} from 'depop/router';

import aboutRoutes from 'depop/apps/about';
import eventsRoutes from 'depop/apps/events';
import shopRoutes from 'depop/apps/shops';
import searchRoutes from 'depop/apps/search';
import passwordRoutes from 'depop/apps/password';

export default (
  <Route path="/">
    <IndexRoute
      getComponent={(location, cb) =>
        loadRoute(import('./apps/root/views/Homepage'), cb)}
      queries={ViewerQueries}
      render={render}
      prepareParams={prepareInfiniteScrollParams}
    />
    {searchRoutes}
    {aboutRoutes}
    {eventsRoutes}
    {passwordRoutes}
    {shopRoutes}
  </Route>
);



// WEBPACK FOOTER //
// ../src/client/routes.js